import React, {forwardRef, useEffect, useImperativeHandle, useState} from 'react';
import './scss/user-cards.scss';
import ICardFilter from "../models/cards-filter";
import CardsFilterProp from "./properties/cards-filter";
import {Form} from 'react-bootstrap';

function CardsFilter({onApplyFilter}: CardsFilterProp, ref: React.Ref<any>): React.ReactElement {

    const defaultFilter: ICardFilter = {};
    const [filter, setFilter] = useState(defaultFilter);

    useEffect(() => {
        onApplyFilter(filter)
    }, [filter]);

    useImperativeHandle(ref, () => ({
        reset() {
            setFilter(defaultFilter);
        },
    }));

    return (
        <div className="row filter justify-content-center">
            <div className="col-3">
                <input
                    type="text"
                    className="form-control w-100"
                    placeholder="Card Name"
                    value={filter.name || ""}
                    onChange={(e) => setFilter({...filter, name: e.target.value})}
                />
            </div>
            <div className="col-3">
                <input
                    type="number"
                    className="form-control w-100"
                    placeholder="Player Card Level Id"
                    value={filter.playerCardLevelId || undefined}
                    onChange={(e) => {
                        setFilter({...filter, playerCardLevelId: Number(e.target.value)}
                        )
                    }}
                />
            </div>
            <div className="col-3">
                <input
                    type="number"
                    className="form-control w-100"
                    placeholder="Card Level Id"
                    value={filter.level?.unid || undefined}
                    onChange={(e) => {
                        setFilter({...filter, level: {...filter.level, unid: Number(e.target.value)}}
                        )
                    }}
                />
            </div>
            <div className="col-3">
                <Form.Select
                    aria-label="Select blockchain"
                    value={filter.level?.blockchain === undefined ? "undefined" : String(Number(filter.level?.blockchain))}
                    className="text-capitalize w-100"
                    style={{cursor: "pointer"}}
                    onChange={(e) => {
                        setFilter({
                            ...filter,
                            level: {
                                ...filter.level,
                                blockchain: (e.target.value == "undefined" ? undefined : Boolean(Number(e.target.value)))
                            }
                        })
                    }}
                >
                    <option key={0} className="w-100" value={"undefined"}>All</option>
                    <option key={1} className="w-100" value={"0"}>In Game</option>
                    <option key={2} className="w-100" value={"1"}>On Blockchain</option>
                </Form.Select>
            </div>
        </div>
    );
}

export default forwardRef(CardsFilter);

